import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import { useTranslation } from 'react-i18next';

Partner.propTypes = {
    data: PropTypes.array,
};

function Row({ items, reverse }) {
    // Uzluksiz aylanish uchun ro'yxat ikki marta chiziladi
    const loop = [...items, ...items];

    return (
        <div className="partner-marquee">
            <div className={`partner-track${reverse ? ' reverse' : ''}`}>
                {loop.map((item, idx) => (
                    <div className="partner-logo" key={`${item.name}-${idx}`} title={item.name}>
                        <img src={item.img} alt={item.name} width="504" height="304" loading="lazy" />
                    </div>
                ))}
            </div>
        </div>
    );
}

function Partner(props) {
    const { data } = props;
    const { t } = useTranslation();

    const half = Math.ceil(data.length / 2);

    return (
        <section className="tf-section partner">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title mb-50" data-aos="fade-up" data-aos-duration="800">
                            <p className="h8 sub-title">{t('partners')}</p>
                            <h2 className="title">{t('clients')}</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div data-aos="fade-up" data-aos-duration="800">
                <Row items={data.slice(0, half)} />
                <Row items={data.slice(half)} reverse />
            </div>
        </section>
    );
}

export default Partner;
